import {useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {setModalTx} from '../../reducers/app/actions';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Copy from '../components/copy';
import Selector from '../../selectors/modals/tx_details';
import {cancelCashAppCashoutRequest} from '../../reducers/app/actions';

export default ({tx}) => {
    const dispatch = useDispatch(),
          [close, setClose] = useState(false),
          {button} = useSelector(Selector);
    
    const blur = useRef(),
          modal = useRef();

    const closeHandler = () => {
        if(close)
            return;

        setClose(true);

        if(blur.current) {
            blur.current.classList.remove('animate__animated');
            blur.current.classList.remove('animate__fadeIn');
            blur.current.classList.add('animate__fadeOut');
            blur.current.classList.add('animate__animated');
        }

        if(modal.current) {
            modal.current.classList.remove('animate__animated');
            modal.current.classList.remove('animate__fadeInUp');
            modal.current.classList.add('animate__fadeOutDown');
            modal.current.classList.add('animate__animated');
        }

        setTimeout(() => {
            dispatch(setModalTx(null));
        }, 1e3);
    }

    return (
        <>
            <div className="blur animate__animated animate__fadeIn" ref={blur} onClick={e => closeHandler()}></div>
            <div className="modal modal-details animate__animated animate__fadeInUp" ref={modal}>
                <div className="modal-header">
                    <div className="title">Details transactions</div>
                    <div className="close" onClick={e => closeHandler()}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#1E1F1F"/>
                            <path d="M15 25.8483L25.8483 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M25.8483 25.8483L15 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                {(tx.is_20_system && tx.status === "pending") && (
                    <div className="transaction-warning">
                        <div className="warn-header">
                            <div className="title">Withdrawal Canceling</div>
                            <div className="verify" style={{
                                opacity: button ? 0.7 : 1,
                                cursor: button ? 'no-drop' : 'pointer'
                            }} onClick={e => {
                                if(button)
                                    return;

                                dispatch(cancelCashAppCashoutRequest(tx.transaction_id));
                                closeHandler();
                            }}>{!button ? 'Cancel' : 'Please wait..'}</div>
                        </div>
                        <div className="text">You can cancel the withdrawal request, your funds will be refunded in full.</div>
                    </div>
                )}

                <div className="transaction">
                    <div className="title">Transaction ID</div>
                    <div className="value">
                        <div className="tx">#{tx.transaction_id}</div>
                        <Copy fill="#fff" size={24} value={`${tx.prefix} transaction ${tx.transaction_id} for $${tx.amount}`} />
                    </div>
                </div>

                {tx.tables.map((tbls, key) => {
                    return (
                        <div className="table" key={key}>
                            {tbls.map((option, key2) => {
                                return (
                                    <div className="table-row" key={key2}>
                                        <div className="label">{option[0]}</div>
                                        {option[0] === "Transaction ID" ? (
                                            <div className="value">
                                                <div style={{maxWidth: "33vw", float: "left", overflow: "hidden", textOverflow: "ellipsis", marginRight: "6px"}}>{option[1]}</div>
                                                {option[0] === "Transaction ID" && (
                                                    <Copy fill={'#ffffff'} size={24} value={option[1]} style={{float: 'left'}} />
                                                )}
                                            </div>
                                        ) : (
                                            <div className="value">
                                                {option[1]}
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div> 
                    )
                })}

                <div className="table">
                    <div className="table-row">
                        <div className="label">Status</div>
                        {tx.status === "pending" && (<div className="value">Pending</div>)}
                        {tx.status === "canceled" && (<div className="value red">Canceled</div>)}
                        {tx.status === "confirmed" && (<div className="value green">Confirmed</div>)}
                        {tx.status === "refunded" && (<div className="value">Refunded</div>)}
                    </div>
                    <div className="table-row">
                        <div className="label">Date</div>
                        <div className="value">{new Date(tx.timestamp).toLocaleString()}</div>
                    </div>
                </div>

                <div className="table">
                    <div className="table-row">
                        <div className="label white">Total amount</div>
                        {['output', 'transfer-out', 'manual-out'].includes(tx.type) && (
                            <div className="value">
                                {/* <span className="symbol">$</span> */}
                                <span className="amount red" style={{color: "#ff7474"}}>- ${tx.total}</span>
                            </div>
                        )}

                        {['input', 'transfer-in', 'manual-in'].includes(tx.type) && (
                            <div className="value">
                                {/* <span className="symbol">+ $</span> */}
                                <span className="amount">+ ${tx.total}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )    
}